import { mode, StyleFunctionProps } from "@chakra-ui/theme-tools";
import { colors } from "../colors";

const chakraBaseStyle = (props: StyleFunctionProps) => ({
  label: {
    color: "muted",
    fontWeight: "medium",
  },
  control: {
    bg: mode("white", "gray.800")(props),
    borderRadius: "base",
  },
});

const baseStyle = (props: StyleFunctionProps) => ({
  ...chakraBaseStyle(props),
  control: {
    borderColor: colors.th.signatureGreen,
    borderRadius: "none",
  },
});

const chakraDefaultProps = {
  colorScheme: "th.actionLavenderPrimary",
};

const defaultProps = {
  ...chakraDefaultProps,
};

const chakraSizes = {
  md: {
    label: {
      fontSize: "sm",
    },
  },
};

const sizes = {
  ...chakraSizes,
};

const variants = {
  "th-checkbox": (props: StyleFunctionProps) => ({
    ...chakraBaseStyle(props),
    control: {
      _checked: {
        bg: "th.actionLavenderPrimary",
        color: "th.black",
        border: "unset",
        _hover: {
          bg: "th.actionLavenderPrimary",
          color: "th.black",
          border: "unset",
        },
      },
      bg: "th.white",
      border: "1px solid",
      borderColor: "th.cream3",
      borderRadius: "4px",
      color: "transparent",
    },
  }),
};

export const Checkbox = {
  baseStyle,
  defaultProps,
  sizes,
  variants,
};
